<!-- ----------------------------------------------- -->
<template>
  <v-sheet id="panel" tile>
    <div class="pnl-tab">
      <v-bottom-navigation
        v-if="!pcPanelMode"
        v-model="tabSelect"
        class="pnl-btn"
        color="success"
      >
        <v-btn
          value="/kawabou/pc/ov"
          class="pa-0 tab-size"
          @click="navRouterPush('/pc/ov')"
        >
          <span class="tab-text">{{ text.ov }}</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">report_problem</v-icon>
            </template>
            <span>{{ text.ov }}</span>
          </v-tooltip>
        </v-btn>
        <v-btn
          value="/kawabou/pc/rwlist"
          class="pa-0 tab-size"
          @click="navRouterPush('/pc/rwlist')"
        >
          <span class="tab-text">{{ text.rwlist }}</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">error</v-icon>
            </template>
            <span>{{ text.rwlist }}</span>
          </v-tooltip>
        </v-btn>
        <v-btn
          v-if="$route.path === '/pc/rw'"
          value="/kawabou/pc/rw"
          class="pa-0 tab-size"
          @click="navRouterPush('/pc/rw')"
        >
          <span class="tab-text">{{ text.rw }}</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">error_outline</v-icon>
            </template>
            <span>{{ text.rw }}</span>
          </v-tooltip>
        </v-btn>
        <v-btn
          value="/kawabou/pc/tmlist"
          class="pa-0 tab-size"
          @click="navRouterPush('/pc/tmlist')"
        >
          <span class="tab-text">{{ text.tmlist }}</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">home_work</v-icon>
            </template>
            <span>{{ text.tmlist }}</span>
          </v-tooltip>
        </v-btn>
        <v-btn
          v-if="$route.path === '/pc/tm'"
          value="/kawabou/pc/tm"
          class="pa-0 tab-size"
          @click="navRouterPush('/pc/tm')"
        >
          <span class="tab-text">{{ text.tm }}</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">home</v-icon>
            </template>
            <span>{{ text.tm }}</span>
          </v-tooltip>
        </v-btn>
        <v-btn
          value="/kawabou/pc/rp"
          class="pa-0 tab-size"
          @click="clickRpTab()"
        >
          <span class="tab-text">{{ text.rp }}</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">house</v-icon>
            </template>
            <span>{{ text.rp }}</span>
          </v-tooltip>
        </v-btn>
        <v-btn
          value="/kawabou/pc/rd"
          class="pa-0 tab-size"
          @click="navRouterPush('/pc/rd')"
        >
          <span class="tab-text">{{ text.rd }}</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">rss_feed</v-icon>
            </template>
            <span>{{ text.rd }}</span>
          </v-tooltip>
        </v-btn>
        <v-btn
          value="/kawabou/pc/iu"
          class="pa-0 tab-size"
          @click="navRouterPush('/pc/iu')"
        >
          <span class="tab-text">{{ text.iu }}</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">waves</v-icon>
            </template>
            <span>{{ text.iu }}</span>
          </v-tooltip>
        </v-btn>
        <v-btn
          value="/kawabou/pc/vc"
          class="pa-0 tab-size"
          @click="navRouterPush('/pc/vc')"
        >
          <span class="tab-text">{{ text.vc }}</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">build</v-icon>
            </template>
            <span>{{ text.vc }}</span>
          </v-tooltip>
        </v-btn>
        <v-btn
          v-if="isAdmin"
          value="/kawabou/pc/ad"
          class="pa-0 tab-size"
          @click="navRouterPush('/pc/ad')"
        >
          <span class="tab-text">{{ text.ad }}</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">supervisor_account</v-icon>
            </template>
            <span>{{ text.ad }}</span>
          </v-tooltip>
        </v-btn>
      </v-bottom-navigation>
      <!-- 拡大モード -->
      <v-tabs v-else v-model="tabActiv" show-arrows>
        <v-tab id="0" @click="clickExpTab('/pc/ov', 'rw')">
          {{ text.ovrw }}
        </v-tab>
        <v-tab id="1" @click="clickExpTab('/pc/ov', 'tm')">
          {{ text.ovtm }}
        </v-tab>
        <v-tab id="2" @click="clickExpTab('/pc/tmlist')">
          {{ text.tmlist }}
        </v-tab>
        <v-tab
          v-if="$route.path === '/pc/tm'"
          id="3"
          @click="clickExpTab('/pc/tm')"
        >
          {{ text.tm }}
        </v-tab>
        <div class="tab-btn-box">
          <v-btn class="mt-1 ml-4" @click="clickMapBtn()">{{ text.map }}</v-btn>
        </div>
      </v-tabs>
    </div>
    <v-col>
      <router-view
        name="contents"
        v-if="tabSelect.startsWith('/kawabou/pc/ov')"
      ></router-view>
      <keep-alive>
        <router-view
          name="contents"
          v-if="tabSelect.startsWith('/kawabou/pc/tmlist')"
        ></router-view>
      </keep-alive>
      <router-view
        name="contents"
        v-if="$route.path === '/pc/tm'"
      ></router-view>
      <router-view
        name="contents"
        v-if="tabSelect.startsWith('/kawabou/pc/rw')"
      ></router-view>
      <router-view
        name="contents"
        v-if="tabSelect.startsWith('/kawabou/pc/rp')"
      ></router-view>
      <router-view
        name="contents"
        v-if="tabSelect.startsWith('/kawabou/pc/rd')"
      ></router-view>
      <router-view
        name="contents"
        v-if="tabSelect.startsWith('/kawabou/pc/iu')"
      ></router-view>
      <router-view
        name="contents"
        v-if="tabSelect.startsWith('/kawabou/pc/vc')"
      ></router-view>
      <router-view
        name="contents"
        v-if="tabSelect.startsWith('/kawabou/pc/ad')"
      ></router-view>
    </v-col>
  </v-sheet>
</template>
<!-- ----------------------------------------------- -->
<script>
import mixin from "./../../lib/mixin.js";
import WebStorage from "./../../lib/webStorage.js";
/**
 * 川の防災情報 PCパネル
 * Panel.vue
 * @author LIS
 */
export default {
  mixins: [mixin],
  /** タグ名 */
  name: "kwb-pc-panel",
  data() {
    return {
      tabSelect: "/pc/ov",
      tabActiv: 0,
      /** 文字列リソース */
      text: {
        ov: "概況",
        ovrw: "発表情報概況",
        ovtm: "基準値超過観測所一覧",
        tmlist: "観測所一覧",
        tm: "観測所",
        rwlist: "発表情報一覧",
        rw: "発表情報",
        rp: "登録地点",
        rd: "レーダ雨量",
        iu: "浸水想定",
        vc: "表示設定",
        ad: "管理者",
        map: "地図画面に戻る",
      },
    };
  },
  beforeMount() {
    let tab = location.pathname;
    let exp = this.$route.query["ext"];
    let ovmd = this.$route.query["ovmd"];
    if (exp && ovmd) {
      tab += "/" + ovmd;
    }
    this.tabSelect = tab;

    if (exp) {
      switch (location.pathname) {
        case "/kawabou/pc/ov":
          if (ovmd === "rw") {
            this.tabActiv = 0;
          } else if (ovmd === "tm") {
            this.tabActiv = 1;
          }
          break;
        case "/kawabou/pc/tmlist":
          this.tabActiv = 2;
          break;
        case "/kawabou/pc/tm":
          this.tabActiv = 3;
          break;
      }
    }
  },
  beforeUpdate() {
    let tab = location.pathname;
    let exp = this.$route.query["ext"];
    let ovmd = this.$route.query["ovmd"];
    if (exp && ovmd) {
      tab += "/" + ovmd;
    }
    this.tabSelect = tab;

    if (exp) {
      switch (location.pathname) {
        case "/kawabou/pc/ov":
          if (ovmd === "rw") {
            this.tabActiv = 0;
          } else if (ovmd === "tm") {
            this.tabActiv = 1;
          }
          break;
        case "/kawabou/pc/tmlist":
          this.tabActiv = 2;
          break;
        case "/kawabou/pc/tm":
          this.tabActiv = 3;
          break;
      }
    }
  },
  computed: {
    /** PCパネル拡大表示モード */
    pcPanelMode: {
      get() {
        return this.$store.state.app.pcPanelMode;
      },
    },
    /** 管理者モード */
    isAdmin: {
      get() {
        let is = false;
        if (
          global.KWB_MODE === "admin" &&
          this.$store.state.app.config != null &&
          this.$store.state.app.config.administratorConfig != null &&
          this.$store.state.app.config.administratorConfig.enable != null
        ) {
          is = this.$store.state.app.config.administratorConfig.enable;
        }
        return is;
      },
    },
  },
  methods: {
    /** 拡大パネル情報 */
    stopLargeMode(path) {
      // パネルの拡大を停止
      // this.$log.debug("[panel]pchangePanelMode(false)");
      // this.$store.commit("app/setPcPanelMode", false);

      this.tabSelect = path;
    },
    /** 拡大時のタブクリック */
    clickExpTab(path, ovmd) {
      let tab = path;
      if (ovmd) {
        tab += "/" + ovmd;
      }
      this.tabSelect = tab;
      this.routerPushExp(path, ovmd);
    },
    /** 地点登録タブクリック */
    clickRpTab() {
      // 地点が未登録の場合は地点登録（表示設定画面）へ遷移
      let isInfo = false;
      let idx = 0;

      // 初期表示設定に地点が選択されている場合は、そこに遷移
      let info = WebStorage.getDefaultInfo();
      if (info && info.point1) {
        isInfo = true;
        idx = 0;
      } else if (info && info.point2) {
        isInfo = true;
        idx = 1;
      } else if (info && info.point3) {
        isInfo = true;
        idx = 2;
      } else if (info && info.point4) {
        isInfo = true;
        idx = 3;
      } else if (info && info.point5) {
        isInfo = true;
        idx = 4;
      }

      // 初期表示設定が全国の場合は、登録されている一番上の地点に遷移
      if (!isInfo) {
        for (let i = 1; i <= WebStorage.length(); i++) {
          info = WebStorage.getPointInfo(i);
          if (info != null && info.name != null && info.pointIndex != null) {
            isInfo = true;
            idx = i - 1;
            break;
          }
        }
      }
      if (isInfo) {
        // 登録地点へ地図を移動
        this.$store.dispatch("map/moveMapPoint", {
          latLng: this.$store.state.map.point.get(idx + 1).center,
          flyto: true,
        });
        // 登録地点情報へ遷移
        this.$store.commit("map/setSelectPointIndex", idx);
        this.routerPushPoint("/pc/rp");
      } else {
        // 登録地点がない場合設定画面へ遷移するが、遷移済みの場合再度遷移させない
        if (this.$route.path === "/pc/vc") {
          return;
        }
        // 表示設定へ遷移
        this.routerPush("/pc/vc");
      }
    },
    /** 地図に戻るボタンクリック */
    clickMapBtn() {
      this.$store.commit("app/setPcPanelMode", false);
      this.$store.commit("app/setPcPanelModeContent", "");
      this.$store.commit("map/mapRedraw");
      this.$store.commit("RiverWarn/setOverviewPref", 0);
      let setQuery = Object.assign({}, this.$route.query);
      delete setQuery["ext"];
      delete setQuery["ovmd"];
      this.$router.replace({
        path: this.$route.path,
        query: setQuery,
      });
    },
    /** ナビゲーション内ボタンクリック */
    navRouterPush(path) {
      // 同じパスの場合は、遷移しない
      if (this.$route.path === path) {
        return;
      }
      this.$router.push(this.getRouterValue(path));
    }
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
#panel {
  display: flex;
  flex-direction: column;
  z-index: 3100;
  width: 100%;
  height: 100%;

  .pnl-tab {
    height: 48px;
    min-height: 48px;
  }

  .pnl-btn {
    box-shadow: none;
  }

  .tab-size {
    min-width: 64px;
    max-height: 60px;
  }

  .tab-text {
    font-size: 0.5em;
  }

  .tab-btn-box {
    display: flex;
    align-items: center;
  }
}
</style>
